export const GET_DASHBOARDS = 'DASHBOARD:GET_DASHBOARDS';
export const GET_DASHBOARDS_SUCCESS = 'DASHBOARD:GET_DASHBOARDS_SUCCESS';
export const OPEN_EVENT_SCORES = 'DASHBOARD:OPEN_EVENT_SCORES';
export const CLOSE_EVENT_SCORES = 'DASHBOARD:CLOSE_EVENT_SCORES';
export const TOGGLE_DASHBOARD_MODAL = 'DASHBOARD:TOGGLE_DASHBOARD_MODAL';
export const SET_SELECTED_COMPONENTS = 'DASHBOARD:SET_SELECTED_COMPONENTS';
export const SET_SORT_ORDER = 'DASHBOARD:SET_SORT_ORDER';
export const SET_TMP_COMPONENTS = 'DASHBOARD:SET_TMP_COMPONENTS';